// ~40 named vinyl base-color presets. Users can also pick any custom HSL
// color via the full color picker — this list is just a curated shortcut.
export const VINYL_PRESETS = [
  { name: 'Jet Black', hex: '#0a0a0a' },
  { name: 'Classic Black', hex: '#151515' },
  { name: 'Crystal Clear', hex: '#d8d8d8' },
  { name: 'Ruby Red', hex: '#8c1c2b' },
  { name: 'Cherry Red', hex: '#a3223a' },
  { name: 'Blood Red', hex: '#6e0f16' },
  { name: 'Sunburst Orange', hex: '#c9612a' },
  { name: 'Tangerine', hex: '#d9772e' },
  { name: 'Golden Yellow', hex: '#d1a327' },
  { name: 'Lemon Yellow', hex: '#e2c23a' },
  { name: 'Sun Yellow', hex: '#e8d24f' },
  { name: 'Olive Green', hex: '#5c5b2d' },
  { name: 'Forest Green', hex: '#2c4a2e' },
  { name: 'Emerald Green', hex: '#1f5c40' },
  { name: 'Mint Green', hex: '#7fc8a9' },
  { name: 'Teal', hex: '#1f5c5c' },
  { name: 'Sky Blue', hex: '#5a8fc0' },
  { name: 'Royal Blue', hex: '#2a4d8f' },
  { name: 'Cobalt Blue', hex: '#22417a' },
  { name: 'Navy Blue', hex: '#151f3d' },
  { name: 'Indigo', hex: '#2e2158' },
  { name: 'Violet', hex: '#5a3d7a' },
  { name: 'Purple Haze', hex: '#4a2c5e' },
  { name: 'Magenta', hex: '#8f2361' },
  { name: 'Hot Pink', hex: '#c23b7a' },
  { name: 'Baby Pink', hex: '#d98fa8' },
  { name: 'Rose Gold', hex: '#b8836b' },
  { name: 'Champagne', hex: '#d8c6a3' },
  { name: 'Ivory', hex: '#e8e2d0' },
  { name: 'Cream', hex: '#e0d5b8' },
  { name: 'Silver', hex: '#9a9a9a' },
  { name: 'Platinum', hex: '#b5b5b0' },
  { name: 'Gunmetal Grey', hex: '#3a3d40' },
  { name: 'Slate Grey', hex: '#4a4f57' },
  { name: 'Charcoal', hex: '#2b2b2b' },
  { name: 'Chocolate Brown', hex: '#4a2f1f' },
  { name: 'Sand', hex: '#c2a878' },
  { name: 'Copper', hex: '#a15c33' },
  { name: 'Bronze', hex: '#7a5230' },
  { name: 'Glow Green', hex: '#4a7a3a' },
];

export const VINYL_FINISHES = [
  { id: 'solid', label: 'Solid' },
  { id: 'splatter', label: 'Splatter' },
  { id: 'marble', label: 'Marble' },
];
